import { GoogleAdDescription, GoogleAdHeadline } from "@/services/ads";
import * as lodash from "lodash-es";

export function isGoogleAdHeaderArray(
  headlines: GoogleAdHeadline[] | string[],
): headlines is GoogleAdHeadline[] {
  return typeof headlines[0] === "object" && "pinned" in headlines[0];
}
export function isGoogleAdDescriptionArray(
  descriptions: GoogleAdHeadline[] | string[],
): descriptions is GoogleAdDescription[] {
  return typeof descriptions[0] === "object" && "pinned" in descriptions[0];
}

export function getGoogleAdsHeadlines(
  headlines: GoogleAdHeadline[],
  count: 1 | 2 | 3,
): GoogleAdHeadline[] {
  const returnArray: GoogleAdHeadline[] = [];
  const unpinned: GoogleAdHeadline[] = [];
  const sortedHeadlines = {
    "1": [] as GoogleAdHeadline[],
    "2": [] as GoogleAdHeadline[],
    "3": [] as GoogleAdHeadline[],
  };
  headlines.forEach((hl) => {
    if (hl.pinned === null) unpinned.push(hl);
    else sortedHeadlines[hl.pinned].push(hl);
  });
  if (sortedHeadlines["1"].length > 0 && count >= 1) {
    returnArray[0] = lodash.sample(sortedHeadlines["1"]) as GoogleAdHeadline;
  } else {
    returnArray[0] = lodash.sample(unpinned) as GoogleAdHeadline;
    lodash.remove(
      unpinned,
      (headline) => headline.text === returnArray[0].text,
    );
  }
  if (sortedHeadlines["2"].length > 0 && count >= 2) {
    returnArray[1] = lodash.sample(sortedHeadlines["2"]) as GoogleAdHeadline;
  } else {
    returnArray[1] = lodash.sample(unpinned) as GoogleAdHeadline;
    lodash.remove(
      unpinned,
      (headline) => headline.text === returnArray[1].text,
    );
  }
  if (sortedHeadlines["3"].length > 0 && count >= 3) {
    returnArray[2] = lodash.sample(sortedHeadlines["3"]) as GoogleAdHeadline;
  } else {
    returnArray[2] = lodash.sample(unpinned) as GoogleAdHeadline;
    lodash.remove(
      unpinned,
      (headline) => headline.text === returnArray[2].text,
    );
  }
  return returnArray;
}
export function getGoogleAdsDescriptions(
  descriptions: GoogleAdDescription[],
  count: 1 | 2,
): GoogleAdDescription[] {
  const returnArray: GoogleAdDescription[] = [];
  const unpinned: GoogleAdDescription[] = [];
  const des = {
    "1": [] as GoogleAdDescription[],
    "2": [] as GoogleAdDescription[],
  };
  descriptions.forEach((hl) => {
    if (hl.pinned === null) unpinned.push(hl);
    else des[hl.pinned].push(hl);
  });
  if (des["1"].length > 0 && count >= 1) {
    returnArray[0] = lodash.sample(des["1"]) as GoogleAdDescription;
  } else {
    returnArray[0] = lodash.sample(unpinned) as GoogleAdDescription;
    lodash.remove(unpinned, (desc) => desc.text === returnArray[0].text);
  }
  if (des["2"].length > 0 && count === 2) {
    returnArray[1] = lodash.sample(des["2"]) as GoogleAdDescription;
  } else {
    returnArray[1] = lodash.sample(unpinned) as GoogleAdDescription;
    lodash.remove(unpinned, (desc) => desc.text === returnArray[1].text);
  }
  return returnArray;
}
